import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageRuleAction } from '../coverageRule.action';
import { CoverageRuleTranslator } from '../coverageRule.translator';

type IDependencies = ICoverageApiDependencySegment;

export const validateCoverageRuleEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageRuleAction.validate.started),
  switchMap((params) => {
    const rules = params.rules.map(CoverageRuleTranslator.toApi);
    return coverageApi.validateCoverageRules(params.ruleSetId, { rules }).pipe(
      mergeMap((response) => [
        CoverageRuleAction.validate.done({
          params,
          result: (response.rules ?? []).map(CoverageRuleTranslator.fromApiValidation),
        }),
      ]),
      catchApiError((error) => {
        // Rules named by a 400 (B-Book + LP) are row feedback, not a toast; anything else stays one.
        const { result, restError } = CoverageRuleTranslator.fromApiRejection(error);
        return [
          CoverageRuleAction.validate.failed({ params, error }),
          ...(result.length > 0 ? [CoverageRuleAction.validationRejected({ ruleSetId: params.ruleSetId, result })] : []),
          ...(restError ? [createApiErrorNotification(restError)] : []),
        ];
      }),
    );
  }),
);
